import { store } from '@/store';
import QuestionBuilder from './QuestionBuilder';

export default class BodyStyleQuestionBuilder extends QuestionBuilder {
    public constructor() {
        super(true, true);
    }

    answers() {
        return store.getters['vehicleSearchModule/bodystyles'];
    }

    setAnswer(answer: string) {
        store.dispatch('vehicleModule/submitBodystyle', [answer]);
        store.dispatch('vehicleSearchModule/updateFilteredResults');
    }
}
